import type { z } from 'zod'

/**
 * Parse data using Zod type guard
 */
export function parseDataOfType<T extends z.ZodTypeAny>(data: unknown, schema: T) {
  const parsed = schema.safeParse(data)
  if (!parsed.success) {
    const errorMessage = `Failed to parse data for type: '${
      schema.description ?? 'TypeName missing, add description to Zod schema'
    }'`
    let serialisedData: string
    try {
      serialisedData = JSON.stringify(data, null, 2)
    } catch {
      serialisedData = '[unserialisable]'
    }
    console.log(`${errorMessage}, got: ${serialisedData} \nerror: ${parsed.error.message}`)
    throw new Error(errorMessage)
  }
  return parsed.data
}

/**
 * Validate data type using Zod
 */
export function isDataOfType<T extends z.ZodTypeAny>(data: unknown, schema: T): data is z.infer<T> {
  return schema.safeParse(data).success
}

/**
 * Creates a TanStack Form field onChange validator from a Zod schema.
 * Returns the first error message on failure, or undefined when valid.
 */
export function zodFieldValidator<T>(schema: z.ZodType<T>) {
  return ({ value }: { value: T }) => {
    const result = schema.safeParse(value)
    return result.success ? undefined : result.error.issues[0]?.message
  }
}
